import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { API_URL } from './pendShared';

export const Nova72hTab = () => {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    axios.get(`${API_URL}/leads/novas-72h`, { params: { mine: false } })
      .then(({ data }) => setRows(data))
      .catch(() => setRows([]));
  }, []);
  if (!rows) return <div className="text-sm text-slate-400 py-8 text-center">A carregar…</div>;
  if (!rows.length) return <div className="text-sm text-slate-400 py-8 text-center" data-testid="nova72-tab-empty">Nenhuma lead em "Nova" há mais de 72h.</div>;
  const byCom = rows.reduce((acc, l) => { (acc[l.assigned_to_name || '—'] ||= []).push(l); return acc; }, {});
  return (
    <div className="space-y-4" data-testid="nova72-tab">
      <p className="text-xs text-slate-500">Estes comerciais estão bloqueados por uma janela até atualizarem o estado de cada lead.</p>
      {Object.entries(byCom).map(([nome, list]) => (
        <div key={nome} className="rounded-xl border border-slate-200 bg-white">
          <p className="px-4 py-2 border-b border-slate-100 font-semibold text-slate-800">{nome} <span className="text-rose-600">({list.length})</span></p>
          <ul className="divide-y divide-slate-50">
            {list.map((l) => (
              <li key={l.id} className="px-4 py-2 flex items-center justify-between text-sm" data-testid={`nova72-tab-row-${l.id}`}>
                <Link to={`/leads/${l.id}`} className="text-[#2D3E6F] hover:underline">{l.client_name || 'Cliente'}</Link>
                <span className="text-[11px] font-bold text-rose-700 bg-rose-100 rounded-full px-2 py-0.5">há {Math.floor(l.horas / 24)}d {l.horas % 24}h</span>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
};
